"use strict";
exports.__esModule = true;
exports.HousesSystem = exports.ElementType = exports.SignType = exports.EPatternName = exports.AspectType = exports.ObjectType = void 0;
var ObjectType;
(function (ObjectType) {
    ObjectType[ObjectType["Sun"] = 0] = "Sun";
    ObjectType[ObjectType["Moon"] = 1] = "Moon";
    ObjectType[ObjectType["Mercury"] = 2] = "Mercury";
    ObjectType[ObjectType["Venus"] = 3] = "Venus";
    ObjectType[ObjectType["Mars"] = 4] = "Mars";
    ObjectType[ObjectType["Jupiter"] = 5] = "Jupiter";
    ObjectType[ObjectType["Saturn"] = 6] = "Saturn";
    ObjectType[ObjectType["Uranus"] = 7] = "Uranus";
    ObjectType[ObjectType["Neptune"] = 8] = "Neptune";
    ObjectType[ObjectType["Pluto"] = 9] = "Pluto";
    ObjectType[ObjectType["NorthNode"] = 10] = "NorthNode";
    ObjectType[ObjectType["SouthNode"] = 11] = "SouthNode";
    ObjectType[ObjectType["Lilith"] = 12] = "Lilith";
    ObjectType[ObjectType["Chiron"] = 13] = "Chiron";
    ObjectType[ObjectType["Selena"] = 14] = "Selena";
    ObjectType[ObjectType["House1"] = 15] = "House1";
    ObjectType[ObjectType["House2"] = 16] = "House2";
    ObjectType[ObjectType["House3"] = 17] = "House3";
    ObjectType[ObjectType["House4"] = 18] = "House4";
    ObjectType[ObjectType["House5"] = 19] = "House5";
    ObjectType[ObjectType["House6"] = 20] = "House6";
    ObjectType[ObjectType["House7"] = 21] = "House7";
    ObjectType[ObjectType["House8"] = 22] = "House8";
    ObjectType[ObjectType["House9"] = 23] = "House9";
    ObjectType[ObjectType["House10"] = 24] = "House10";
    ObjectType[ObjectType["House11"] = 25] = "House11";
    ObjectType[ObjectType["House12"] = 26] = "House12";
})(ObjectType = exports.ObjectType || (exports.ObjectType = {}));
var AspectType;
(function (AspectType) {
    AspectType[AspectType["Conjunction"] = 0] = "Conjunction";
    AspectType[AspectType["Seminonagon"] = 20] = "Seminonagon";
    AspectType[AspectType["Semisextile"] = 30] = "Semisextile";
    AspectType[AspectType["Semiquintile"] = 36] = "Semiquintile";
    AspectType[AspectType["Novile"] = 40] = "Novile";
    AspectType[AspectType["Semisquare"] = 45] = "Semisquare";
    AspectType[AspectType["Sextile"] = 60] = "Sextile";
    AspectType[AspectType["Quintile"] = 72] = "Quintile";
    AspectType[AspectType["Binovile"] = 80] = "Binovile";
    AspectType[AspectType["Square"] = 90] = "Square";
    AspectType[AspectType["MinusOrPlus"] = 100] = "MinusOrPlus";
    AspectType[AspectType["Tredecile"] = 108] = "Tredecile";
    AspectType[AspectType["Trine"] = 120] = "Trine";
    AspectType[AspectType["Sesquiquadrate"] = 135] = "Sesquiquadrate";
    AspectType[AspectType["PlusOrMinus"] = 140] = "PlusOrMinus";
    AspectType[AspectType["Biquintile"] = 144] = "Biquintile";
    AspectType[AspectType["Quincunx"] = 150] = "Quincunx";
    AspectType[AspectType["Opposition"] = 180] = "Opposition";
})(AspectType = exports.AspectType || (exports.AspectType = {}));
var EPatternName;
(function (EPatternName) {
    EPatternName["trigon"] = "chronos.app.instruments.widgets.analyze.trigon";
    EPatternName["bisextil"] = "chronos.app.instruments.widgets.analyze.bisextil";
    EPatternName["roof"] = "chronos.app.instruments.widgets.analyze.roof";
    EPatternName["perst"] = "chronos.app.instruments.widgets.analyze.perst";
    EPatternName["cross"] = "chronos.app.instruments.widgets.analyze.cross";
    EPatternName["tau"] = "chronos.app.instruments.widgets.analyze.tau";
    EPatternName["dart"] = "chronos.app.instruments.widgets.analyze.dart";
    EPatternName["axe"] = "chronos.app.instruments.widgets.analyze.axe";
    EPatternName["dagger"] = "chronos.app.instruments.widgets.analyze.dagger";
    EPatternName["wagon"] = "chronos.app.instruments.widgets.analyze.wagon";
    EPatternName["semiWagon"] = "chronos.app.instruments.widgets.analyze.semiWagon";
    EPatternName["trapeze"] = "chronos.app.instruments.widgets.analyze.trapeze";
    EPatternName["sail"] = "chronos.app.instruments.widgets.analyze.sail";
    EPatternName["fence"] = "chronos.app.instruments.widgets.analyze.fence";
    EPatternName["ship"] = "chronos.app.instruments.widgets.analyze.ship";
    EPatternName["palm"] = "chronos.app.instruments.widgets.analyze.palm";
    EPatternName["boat"] = "chronos.app.instruments.widgets.analyze.boat";
    EPatternName["compass"] = "chronos.app.instruments.widgets.analyze.compass";
    EPatternName["lock"] = "chronos.app.instruments.widgets.analyze.lock";
    EPatternName["lasso"] = "chronos.app.instruments.widgets.analyze.lasso";
    EPatternName["cell"] = "chronos.app.instruments.widgets.analyze.cell";
    EPatternName["box"] = "chronos.app.instruments.widgets.analyze.box";
    EPatternName["petrov"] = "chronos.app.instruments.widgets.analyze.petrov";
    EPatternName["stellium"] = "chronos.app.instruments.widgets.analyze.stellium";
})(EPatternName = exports.EPatternName || (exports.EPatternName = {}));
var SignType;
(function (SignType) {
    SignType[SignType["Aries"] = 0] = "Aries";
    SignType[SignType["Taurus"] = 1] = "Taurus";
    SignType[SignType["Gemini"] = 2] = "Gemini";
    SignType[SignType["Cancer"] = 3] = "Cancer";
    SignType[SignType["Leo"] = 4] = "Leo";
    SignType[SignType["Virgo"] = 5] = "Virgo";
    SignType[SignType["Libra"] = 6] = "Libra";
    SignType[SignType["Scorpio"] = 7] = "Scorpio";
    SignType[SignType["Sagittarius"] = 8] = "Sagittarius";
    SignType[SignType["Capricorn"] = 9] = "Capricorn";
    SignType[SignType["Aquarius"] = 10] = "Aquarius";
    SignType[SignType["Pisces"] = 11] = "Pisces";
})(SignType = exports.SignType || (exports.SignType = {}));
var ElementType;
(function (ElementType) {
    ElementType[ElementType["Land"] = 0] = "Land";
    ElementType[ElementType["Air"] = 1] = "Air";
    ElementType[ElementType["Water"] = 2] = "Water";
    ElementType[ElementType["Fire"] = 3] = "Fire";
})(ElementType = exports.ElementType || (exports.ElementType = {}));
;
var HousesSystem;
(function (HousesSystem) {
    HousesSystem[HousesSystem["Placidus"] = 0] = "Placidus";
    HousesSystem[HousesSystem["Koch"] = 1] = "Koch";
    HousesSystem[HousesSystem["Regiomontanus"] = 2] = "Regiomontanus";
    HousesSystem[HousesSystem["Equal"] = 3] = "Equal";
    HousesSystem[HousesSystem["Porphyrius"] = 4] = "Porphyrius";
})(HousesSystem = exports.HousesSystem || (exports.HousesSystem = {}));
